import { render, staticRenderFns } from "./CrowdloanDashboardCard.vue?vue&type=template&id=29edd976&scoped=true&"
import script from "./CrowdloanDashboardCard.vue?vue&type=script&lang=js&"
export * from "./CrowdloanDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./CrowdloanDashboardCard.vue?vue&type=style&index=0&id=29edd976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29edd976",
  null
  
)

export default component.exports